<template>
  <div class="content">
    <transition>
      <router-view />
    </transition>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters(['lang', 'user']),
  },
  mounted() {
    this.updateLang();
  },
};
</script>
